import { FormModal } from "@/components/shared/FormModal";
import { normalizePhone } from "@/lib/phone";
import { api } from "@/lib/api";
import { toast } from "sonner";

const PERSON_TYPES = ["employee", "prospect", "customer_contact", "vendor_contact", "partner", "applicant", "contact"];

// Shared create/edit dialog for a contact (person). Pass `contact` to edit, or `fixedOrgId`
// to lock the organization (used from the Organization page).
export function ContactDialog({ open, onOpenChange, contact, orgs = [], fixedOrgId, onSaved }) {
  const isEdit = !!contact?.id;
  const fields = [
    { name: "first_name", label: "First name", required: true },
    { name: "last_name", label: "Last name", required: true },
    { name: "title", label: "Title" },
    { name: "email", label: "Email" },
    { name: "phone", label: "Phone", type: "phone" },
    ...(fixedOrgId ? [] : [{ name: "organization_id", label: "Organization", type: "select", options: orgs.map((o) => ({ value: o.id, label: o.name })) }]),
    { name: "person_type", label: "Type", type: "select", default: "contact", options: PERSON_TYPES.map((v) => ({ value: v, label: v.replace(/_/g, " ") })) },
  ];
  const initial = isEdit ? contact : (fixedOrgId ? { organization_id: fixedOrgId } : {});
  return (
    <FormModal open={open} onOpenChange={onOpenChange} title={isEdit ? "Edit contact" : "New contact"}
      submitLabel={isEdit ? "Save changes" : "Create"} testid="contact-form-modal" initial={initial} fields={fields}
      onSubmit={async (v) => {
        const payload = { ...v, ...(fixedOrgId ? { organization_id: fixedOrgId } : {}) };
        payload.phone = normalizePhone(payload.phone);
        if (isEdit) await api.put(`/people/${contact.id}`, payload);
        else await api.post("/people", payload);
        toast.success(isEdit ? "Contact updated" : "Contact created");
        onOpenChange(false); onSaved?.();
      }} />
  );
}
